module.exports = __webpack_public_path__ + "static/img/aboutUs-img-a.e97ec7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs-img-a.jpg
// module id = RFJa
// module chunks = 1